import React from 'react';
import getContent from '../lib/dictionaryFetcher';
import PropTypes from 'prop-types';
import { get } from 'lodash';
class RestartQuiz extends React.Component {
  restartFpti = () => {
    const { location, fptiHelper } = this.props;
    fptiHelper.fptiClick({
      page: 'main:businessweb:mep:dashboard:main:quiz:results',
      link: 'restart',
      entry_point: get(location, 'search', '').includes('appcenter=true')
    });
  };
  render() {
    const { marginTop = '0px' } = this.props;
    return (
      <div className="results-restart" style={{ marginTop }}>
        <span className="ppvx_icon ppvx_icon--size_sm ppvx_icon-refresh results-restart-icon" />
        <p className="results-restart-text">
          <a
            className="results-restart-link"
            href="/merchantapps/setup-recommendations"
            onClick={this.restartFpti}
          >
            {getContent('quiz', 'results.restart')}
          </a>
        </p>
      </div>
    );
  }
}
RestartQuiz.propTypes = {
  marginTop: PropTypes.string,
  location: PropTypes.object,
  fptiHelper: PropTypes.object
};
export default RestartQuiz;
